module.exports = {
  not_found: {
    title: 'Something went wrong',
    description: 'Page not found. Error 404',
    linkText: 'if the error persists',
    link: 'contact us',
    please: 'Please'
  },
  premium: 'Premium',
  settings_label: 'Settings',
  get_premium: 'Start Free trial',
  sign_in: 'Sign In',
  sign_out: 'Sign Out',
  learn_more: 'Learn More',
  cancel: 'Cancel',
  ok: 'Ok',
  edit: 'Edit',
  add: 'Add',
  remove: 'Remove',
  save: 'Save',
  submit: 'Submit',
  back: 'Back',
  forgot: 'Forgot password',
  years: 'years',
  url_exists: 'This url already exists',
  links_list: 'in your links list',
  locked: 'Lock',
  unlocked: 'Unlock',
  lock: 'Lock',
  unlock: 'Unlock',
  now: 'now',
  delete: 'Delete',
  start_kids_mode: 'Start KIDS MODE',
  start_kids_mode_error: 'Please, choose relevant device and profile',
  exit_kids_mode: 'Exit KIDS MODE',
  kids_mode: 'KIDS MODE',
  password: 'Password',
  passcode: 'Passcode',
  exit_passcode: 'Exit Passcode',
  start: 'Start',
  help: 'Help',
  confirm: 'Confirm',
  link: 'link',
  lets_try: 'Let’s Try',
  lets_go: 'Let’s Go',
  accept: 'Accept',
  reject: 'Reject',
  menu: {
    settings: {
      title: 'Settings',
    },
    sites: {
      title: 'Sites',
    },
    themes: {
      title: 'Backgrounds',
    },
    statistics: {
      title: 'Statistics',
    },
    remote: {
      title: 'Remote Access',
    },
    profile: {
      title: 'Profile',
    }
  },
  settings: {
    title: 'Settings',
    kid_info: {
      title: 'Kid\'s info',
      kid_name: 'Kid\'s name',
      kid_age: 'Kids age',
      kid_password: 'Kids password'
    },
    lock_configuration: {
      title: 'Lock Settings',
      tooltip: 'Choose your lock setting to set when KIDS MODE will be activated on your browser.',
      lock_start: 'Lock when start',
      lock_start_desc: 'Kids lock is activated automatically every time the browser restart',
      auto_lock: 'Lock Automatically',
      auto_lock_desc: 'If there is no activity with the browser, turn on the KIDS MODE after X min automatically',
      always_top: 'Kids Lock Pinned',
      always_top_desc: 'Kid\'s Lock will be the only screen accessible for your kids, so everything else on your computer can stay safe and secure.',
    },
    remote_lock: {
      title: 'Remote Lock',
      tooltip: 'Control your child\'s online access from a distance with our remote lock feature.',
      give_time: 'Give bonus time',
      unlock_by_unavailable_settings: 'To unlock KidsMode, please, change restricted times settings or daily limit',
    },
    daily_limit: {
      title: 'Daily Limit',
      tooltip: 'Set the maximum number of hours your child can spend online and once they have reached this their access will be blocked.',
      block_description: 'For younger children, age 5 to 8, the recommended limit is one hour per day. For kids age 9 to 12 the new warning from the AHA recommends parents limit screen time for kids to a maximum of just two hours per day.',
    },
    unavailable: {
      title: 'Restricted Times',
      tooltip: 'Set time frames for KIDS MODE to be available for your children, allowing them to spend a healthy amount of time online.',
      edit: 'Edit Restricted Times',
      error: 'Time from must be less that time to',
      additional_main_error: 'Additional time range should be out of main range',
      additional_time_range: 'Additional time range',
      block_day: 'Block all day',
      from: 'From',
      to: 'To',
    }
  },
  sites: {
    title: 'Sites',
    sites_description: 'The internet can be great a great tool for kids. Online they can communicate with teachers and friends, research, learn and play. However spending time online is not without risks, and we are here to help minimise these for you.',
    allow_kid_to_request: 'Allow kids to request access to site',
    allow_kid_to_request_tooltip: 'To use this feature you have to check if your operating system supports notification displaying via the selected browser and the required option in system preferences was turned on',
    allow_kid_to_request_desc: 'Permit your kids to send a request to visit sites not on their list. You can then choose whether to approve or deny. ',
    add_links: 'Add approved links',
    add_links_desc: 'Choose the websites your kid will be able to access',
    useful_websites: 'Recommended useful sites',
    preview: 'Preview',
    add_to_list: 'Add to list',
    oops: 'Oops...',
    can_add_10_links: 'You can only add 10 links',
    to_add_remove: 'To add this, first remove any of the existing',
  },
  themes: {
    title: 'Backgrounds',
    choose_theme: 'Choose the theme based on your kids interest',
    upload_image: 'Upload image',
  },
  statistic: {
    daily_limit: 'Daily limit',
    daily_usage: 'Daily usage',
    last_week: 'Last week',
    last_month: 'Last month',
    week_activity: 'Weekly Activity',
    activity_history: 'Activity History',
    activity_history_tooltip: 'Check up on your kids online activity history and internet usage so you know your child is staying safe and healthy online.',
    activity_history_last: 'Activity history for the last',
    days: 'days',
    today: 'Today',
    week: 'Week',
    month: 'Month',
    site_request: 'has made a request to provide access to this site',
    site_request_accept: 'Accept the site',
    site_request_block: 'Block the site',
    time_request: 'asks you to allow more time',
    time_request_text: 'has made a request to get more time',
    unavailable_request_text: 'If you want to add time - change unavailable settings',
    go_settings: 'Go to settings',
  },
  only_premium: {
    try_premium: 'Try Premium',
    only_for_premium: 'Only for premium users',
    only_premium_description: 'This feature, like many others, is only available for premium accounts.',
  },
  add_link_modal: {
    link: 'link',
    create_link: 'Create custom link',
    enter_link_title: 'Enter link title',
    enter_link_url: 'Enter link url',
    create_link_desc: 'Create link to sites you choose, you can add title url',
    only_premium_description: 'This feature, like many others, is only available for premium accounts.',
  },
  get_premium_modal: {
    title: 'Get Premium',
    titleAndroid: 'Premium subscription',
    monthly: 'Monthly',
    yearly: 'Yearly',
    total: 'Pay Now',
    per_month: 'per month',
    save_20: 'Save 20%',
    percent_off: '20% off',
    get: 'Get',
    two_month_free: '2 months free',
    billing_info: 'Billing information',
    card_text_info: 'Card information is stored on a secure server',
    wait_please: 'Wait, please',
    already_have_premium: 'I already have premium account',
    mobile_only_for_premium: 'Mobile version available only for premium user',
    sign_in_before_get_premium: 'You need to sign in before get premium',
    help: 'Help',
    choose_subscription: 'Choose subscription after trial',
    total_billed: 'Total billed',
    will_remind: 'We will remind you 2 days before your trial period ends',
    features: {
      title: 'What do you get with premium',
      feture_1_title: 'Remote Access',
      feture_1_texts: ['Remote lock', 'Change time limit', 'Allow new sites'],
      feture_2_title: 'Multi Kids',
      feture_2_texts: ['Add more kids', 'Manage all kids', ' Get kids usage report'],
      feture_3_title: 'More devices',
      feture_3_texts: ['Add Android devices', 'Add Window/Mac/Linux devices', 'Control all devices'],
      feture_4_title: 'More Features',
      feture_4_texts: ['Full customization', 'Parent dashboard app', 'Multi parents'],
    }
  },
  premium_success_modal: {
    button: 'Let\'s rock',
    text_part_1: 'Yeah!',
    text_part_2: 'Thanks for subscribing!',
    text_part_3: 'Welcome to the Parent Dashboard Pro!'
  },
  premium_page: {
    title: 'Premium',
    free: 'Free',
    premium: 'Premium',
    description: 'To access these features, you must purchase a premium',
    features: {
      settings: 'Settings',
      settings_additional: {
        lock_when_start: 'Lock when start',
        auto_lock: 'Auto lock',
        remote_lock: 'Remote lock',
        always_top: 'Always on top(kids can only see this app)',
        time_limit: 'Time limit daily for all app',
        screen_time: 'Screen time',
      },
      themes: 'Backgrounds',
      themes_additional: {
        some_theme: 'Some background',
        animated_themes: 'Animated backgrounds',
        upload_bg: 'Upload your background',
      },
      statistic: 'Statistic',
      statistic_additional: {
        configurate_date_range: 'Configurate date range (week/month or custom date)',
      },
      remote_features: 'Remote access features',
      remote_features_additional: {
        access_dashboard_from_web: 'Access dashboard from web',
        get_add_time_remotely: 'Get additional time for kids or lock screen remotely',
        check_stat: 'Check statistic and generate custom link that no need login',
      },
      sites: 'Sites',
      sites_additional: {
        add_links_allow: 'Add links to allow kids',
        allow_kid_request: 'Allow kids to request access to site',
      }
    }
  },
  kid: {
    parent_mode: 'Parent Dashboard Free',
    welcome_back: 'Welcome back!',
    welcome_to: 'Welcome to',
    screen_locked: 'Screen is locked',
    time_over: 'Time\'s Up!',
    time_unavailable: 'The time is unavailable',
    kid_sent_request: 'You already sent request',
    give_more_time: 'I\'d like more time',
    contact_parents_for_more_time: 'Contact your parents if you need more time',
    visit_website: 'Need to visit the site?',
    ask_adult: 'Let’s ask an adult if it’s ok first',
    get_permission: 'Get permission',
    extra_time_request_sent: 'Extra time request has been sent to your parents',
    enter_passcode_add_more_time: 'If you are parent, enter your passcode and add more time',
    add_more_time: 'Add more screen time',
    google_safe_search: 'Google SAFE Search...',
    login: {
      pas_placeholder: 'Enter your passcode',
    },
    forgot: {
      forgot_pas: 'Forgot password?',
      your_pas_is: 'Your password is',
      enter_email: 'Enter your email',
      forgot_error: 'This email is not registered'
    },
    dropdown: {
      title: 'Time left',
      ask_time: 'Ask more time',
      already_sent: 'Already sent',
      get_access: 'Get access to website',
      switch_profile: 'Switch profile',
    },
    welcome: {
      text_item_1: 'This is safe zone for your kids',
      text_item_2: 'This screen is always on and your kids have access only to this screen and the content inside!',
      list_item_1: 'Only sites and apps you approved',
      list_item_2: 'Kids screen time limit',
      list_item_3: 'Usage report and remote monitoring',
    }
  },
  ext: {
    kid_dont_has_access: 'You don\'t have access to this site',
    kid_want_visit_site: 'Need to visit the site? Let\'s ask an adult if it\'s ok first'
  },
  android: {
    permissionSlide: {
      title: 'Permission required',
      label: 'The app need Always on top permission to work properly',
      finish_settings: 'finish base settings'
    }
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Parent Dashboard Pro lets adults manage a child\'s device or there device to enable KIDS MODE. Parents can remotely manage their child’s settings remotely on Parent Dashboard Pro, as well as on their child’s device.',
    tabs: {
      kids: 'Kids',
      kids_description: 'You can check your Kids activity and customize',
      devices: 'Devices'
    },
    device: {
      title: 'Device',
      add_device: 'Add device',
      you_here: 'You are here',
      settings: 'Settings',
      off: 'off',
      on: 'on',
    },
    profile: {
      title: 'Profile',
      active_now: 'Active now on',
      offline_now: 'Offline now',
      time_over: 'Time is over',
      view_profile: 'View profile',
      add_profile: 'Add profile',
      unlimited: 'Unlimited time',
    },
    welcome_screen: {
      feature_text_1: 'Control all devices in one place',
      feature_text_2: 'Add, manage, and supervisor several kids',
      feature_text_3: 'Access from any place and from any device',
    },
    run_kids_mode_modal_title: 'Where would you like to launch KIDS MODE?'
  },
  free_dashboard: {
    how_open_kids_mode: 'How to open KIDS MODE again',
    welcome_parent_mode: 'Welcome to Parent Dashboard Free',
    description: 'Parent Dashboard Free lets parent manage KIDS MODE on the current device.',
    tabs: {
      my_kids: 'My Kids',
      one_time_session: 'One time session',
      kids_description: 'Create each kid their own profile according to age and abilities',
      one_time_session_description: 'Create a new kids mode on this device for a one-time session'
    },
    kids: {
      profile_is_active: 'Profile is already active',
      add_kid: 'Add kid'
    },
    one_time_session: {
      time_limit: 'Time limit',
      allowed_sites: 'Allowed for Kid',
      allowed_all_links: 'Allowed all links',
      choose_sites: 'Choose apps/websites',
      added: 'Added',
      sites: 'sites',
      start_session: 'Start session',
    },
    footer: {
      parent: 'Parent',
      dashboard: 'Dashboard',
      features: 'Need more features?',
      feature_1: 'Add more kids',
      feature_2: 'More devices',
      feature_3: 'Premium features',
    },
    welcome: {
      title: 'Here you can manage KIDS MODE on the current device.',
      feature_1: 'Select kid and Click Start',
      feature_2: 'Use One time session for quick KIDS MODE on the device.'
    },
    how_it_works: {
      title: 'How it works?',
      guest: {
        part_1: 'One time session allow you to give access to websites and apps for specific case.',
        part_2: 'This is good when a parent gives the kid a phone for a short time.',
        part_3: 'This session is not saved and not monitored.',
      },
      kids: {
        part_1: 'You can click to',
        part_2: 'for configure kid profile (allowed websites, themes, screen time etc.)',
        part_3: 'When you click to',
        part_4: 'your browser will be locked and the child will only be able to use permitted websites',
      }
    }
  },
  app: {
    parent_dashboard_decription: 'Parent Dashboard Pro lets adults manage a child\'s device or there device to enable',
    links: {
      add_sites_to_allow: 'Add sites and applications to allow kids',
      add_sites_to_allow_description: 'Here you can add the links which you want to allow access to your child',
      allow_all_sites: 'Allow all sites',
      websites: 'Websites',
      applications: 'Applications',
      add_app: 'Add App',
      add_site: 'Add Website',
    },
    recover: {
      enter_email: 'Enter your email that you used on registration',
      recover_passcode: 'Recover passcode',
      passcode_is: 'Your passcode is',
      dont_have_passcode: 'You don\'t have password',
    },
    passcode: {
      parent_passcode: 'Parent passcode',
      wrong_passcode: 'Wrong passcode',
      your_passcode: 'Your passcode',
      enter_passcode: 'Enter your passcode, please',
      passcode_error: 'Please, check your passcode',
      digits: '4 digits',
      help: 'Help',
      description: 'This passcode is required to exit KIDS MODE and return to regular mode',
    }
  },
  profile: {
    lock: 'Lock',
    profile: 'profile',
    back_to_dashboard: 'Back to Dashboard',
    remove_profile: 'Remove profile',
    cant_delete_profile: 'You can`t delete default profile',
    remove_active_profile_error: 'You can`t delete active profile',
    all_data_will_delete: 'All data will delete.',
    are_you_sure: 'Are you sure?',

  },
  add_profile: {
    personalization: 'Kid personalization',
    choose_time: 'Choose screen time',
    choose_avatar: 'Choose avatar',
    name_error: 'Please, enter kid\'s name (max 15 characters)',
    name_error_length: 'Name is too long (max 15 characters)',
    enter_name: 'Enter kid\'s name (max 15 characters)',
    enter_password: 'Enter kid\'s password',
    avatar_error: 'Max size is exceeded (max 1 mb)',
    create_kid_profile: 'Create kid profile',
    kid_name: 'Kid name',
    create_profile: 'Create profile',
    change_avatar: 'Change avatar',
    upload_avatar: 'Upload avatar',

  },
  registration: {
    congratulations: 'Congratulations',
    parent_account: 'Parent account',
    step_left: 'Only one step left',
    on_creating: "you've created a",
    access_to_your: 'Access to your',
    free: 'FREE',
    parent_account_control_kids: 'parent account to control kids accounts.',

  },
  account: {
    info: 'Account information',
    settings: 'Parent Settings',
    email: 'Email',
    new_name: 'New name',
    name: 'Name',
    enter_name: 'Enter your name',
    name_error: 'The name length should be between 2 and 20 characters',
    enter_old_password: 'Enter old account password',
    enter_new_password: 'Enter new account password',
    change_password: 'Change Account password',
    password_dashboard: 'Password for dashboard',
    password_error: 'This field is required',
    subscription: 'subscription',
    subscription_plan: 'Your subscription plan',
    status: 'Status',
    no_subscription: 'don’t have premium subsription',
    cancel_subscription: 'Cancel subscription',
    current_payment: 'current payment',
    renew_subscription: 'Renew subscription',
    payments_history: 'Payments history',
    hide_history: 'Hide history',
    additional_parent: 'Additional parent',
    additional_parent_placeholder: 'Enter second parent email for invite',
    add_account: 'Add account',
    sent_invite: 'Sent invite',
    linked_account_modal_title: 'You are invited to family account to:',
    linked_account_modal_text: 'You can also manage the profiles and devices created by it',
    linked_account_text: 'Your account is linked to your account',
    linked_account_description: 'You can also manage the profiles and devices created by it.',
    leave: 'Leave',
    parent_accounts: 'Parent accounts'
  },
  add_device: {
    title: 'Choose device what you want to add',
    add_desktop: 'Add Desktop Device',
    add_mobile: 'Add Mobile Device',
    desktop: 'Desktop',
    mobile: 'Mobile',
    several_options: 'You have several options, choose the one that suits you',
    go_chrome_store: 'Go to Chrome store',
    go_google_play: 'Go to Google play',
    go_google_play_description: 'You have several options, choose the one that suits you',
    get_extension: 'Get extension',
    get_app: 'Get the app',
    copy_link: 'Copy link',
    copy_link_description: 'You have several options, choose the one that suits you',
    copy: 'Copy',
    sent_link: 'Sent link to another device',
    sent_link_description: 'You have several options, choose the one that suits you',
    sent_link_to: 'Sent link to',
    mobile_title: 'To use this feature you need to access from android device',
    mobile_text: 'If you don\'t install our app on your android device add it now!',
    mobile_btn: 'ADD IT NOW',
  },
  hints: {
    hiw: 'How it works',
    faq: 'FAQ',
    contact: 'Contact Us',
    terms_privacy: 'Terms & Privacy',
    hide: 'Hide hints',
  },
  help_links: {
    how_we_can_help: 'How we can help you?',
    forgot_passcode: 'Forgot passcode',
    restore_passcode: 'You can restore your passcode',
    contact_description: 'You can contact us using email',
  },
  premium_features: {
    slide_1: {
      title: 'Parent Dashboard Pro',
      text_1: 'A separate application for parental use only, from which you can control various devices remotely',
      text_2: 'Get reports on  your kids\' usage  and browsing statistics',
    },
    slide_2: {
      title: 'Manage Kids',
      text_1: 'Multi kids',
      text_2: 'Screen Time',
      text_3: 'Customize each kid experiences',
      text_4: 'Allow apps and websites',
    },
    slide_3: {
      title: 'Multi-device',
      text_1: 'Desktop and Mobile',
      text_2: 'KIDS MODE on reboot',
      text_3: 'Lock and manage from remote',
    },
    slide_4: {
      title: 'Web access',
      text_1: 'Parent dashboard Pro support iOS/Android/Windows',
      text_2: 'Manage kids and devices from anywhere',
      text_3: 'Allow kids site requests and more time',
    },
    try_trial: 'Try 7 days free trial'
  },
  site_request: {
    title: 'This site is not available, ask your parents to help you',
    sent_request: 'Send request and go back',
  },
  remote_access: {
    description: 'Mobile version available only for premium user',
    try_free_trial: 'Try Free Trial',
    already_have_premium: 'I already have premium account',
  },
  lock_device_profile: 'Lock device with profile',
  kids_mode_on: 'KIDS MODE is On',
  parent_mode: 'Parent Dashboard Free',
  parent_dashboard: 'Parent Dashboard Pro',
  passcode_error: 'The passcode should be 4 digits',
  got_it: 'Got it',
  why_i_see_this: 'Why I see this?',
  choose_account: 'Please choose your account to continue',
  select_kid: 'Select kid',
  kids_mode_on_description: 'When KIDS MODE is On, your device is protected and your kid can use it',
  enter_dashboard: 'You can enter to your dashboard here',
  hi: 'Hi',
  show: 'Show',
  activity: 'activity',
  no_data_yet: 'No data yet',
  allow: 'Allow',
  create: 'Create',
  next: 'Next',
  search: 'Search',
}
